import { SectionContent } from 'app/views/presentations/models/sectionContent.model';

export class NewsModel extends SectionContent {
    constructor(
        public rssSources: string[] = [],
        public newsDuration: number = 20000,
        public customNews: CustomNew[] = [],
        public badwords: {} = { words: [] },
        public filterNews: boolean = true
    ) {
        super();
    }
}

export class CustomNew {
    constructor(
        public title: string = '',
        public content: string = '',
        public logoUrl: string = ''
    ) { }
}

export class Badwords {
    constructor(
        words: string[] = []
    ) { }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/models/rss.model.ts